import React from 'react'

export default function CurrencyListSection({
  isMobile,
  title,
  list = [],
  activeCurrency,
  styles = {},
  onSelectCurrency
}) {
  if (!list?.length) return null
  return (
    <div className={styles.currency_content}>
      {title && <h3 className={styles.currency_content_title}>{title}</h3>}

      <div className={styles.currency_list}>
        {list.map((cur) => {
          const isActive = activeCurrency === cur.code
          return (
            <div
              key={cur.code}
              className={`${styles?.currency_item} ${isActive ? styles.active_currency : ''}`}
              onClick={() => onSelectCurrency && onSelectCurrency(cur.code, cur.name)}
            >
              <div className={styles.currency_info}>
                <span className={styles.currency_code}>{cur.code}</span> -{' '}
                <span className={styles.currency_name}>{cur.name}</span>
              </div>

              {isActive && <span className={styles.active_label}></span>}
            </div>
          )
        })}
      </div>
    </div>

  )
}
